import { render, staticRenderFns } from "./PgfnDebts.vue?vue&type=template&id=4828ae30&"
import script from "./PgfnDebts.vue?vue&type=script&lang=ts&"
export * from "./PgfnDebts.vue?vue&type=script&lang=ts&"
import style0 from "./PgfnDebts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports